
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { LogoLayout } from './useLogoUpload';
import { LayoutTemplate, Square, Maximize } from 'lucide-react';

interface LogoLayoutSelectorProps {
  value: LogoLayout;
  onChange: (value: LogoLayout) => void;
}

export const LogoLayoutSelector: React.FC<LogoLayoutSelectorProps> = ({
  value,
  onChange
}) => {
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">Logo Layout</div>
      <Select 
        value={value} 
        onValueChange={(val) => onChange(val as LogoLayout)}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select logo layout" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="square">
            <div className="flex items-center">
              <Square className="mr-2 h-4 w-4" />
              <span>Square</span>
            </div>
          </SelectItem>
          <SelectItem value="landscape">
            <div className="flex items-center">
              <LayoutTemplate className="mr-2 h-4 w-4" />
              <span>Landscape (Wide)</span>
            </div>
          </SelectItem>
          <SelectItem value="portrait">
            <div className="flex items-center">
              <Maximize className="mr-2 h-4 w-4 rotate-90" />
              <span>Portrait (Tall)</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
      <div className="text-xs text-gray-500">
        Select the shape of your logo to optimize how it appears in previews
      </div>
    </div>
  );
};
